export default [
    {
        path: "/canteen/today-messing-sale",
        component: () => import("@/App/Canteen/Voucher/Messing/Components/List.vue"),
        name: "canteen.today.messing.sale",
        meta: {
            requiresAuth: true,
        },
    },
];
